import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';

import React, { useRef } from 'react';
import { FONTSTYLE, generateToolTip } from 'utils/filterNames';
import {
	ApLoaderDefault,
	ApLoaderText,
	colors,
} from '@alixpartners/ui-components';
import { SectionWrapper } from 'Investigate/Investigate.styles';
import {
	Header,
	Title,
} from 'Investigate/RegionalSection/RegionalSection.styles';
import {
	LoadingContainer,
	NoData,
} from 'Investigate/CommonVendors/CommonVendors.styles';
import { renderToString } from 'react-dom/server';
import Tooltip from '../../Components/Tooltip';
import { getFormattedSpendWithSymbol } from 'utils/number';

function LineChart(props) {
	const { data, breakDownBy } = props;
	const chartRef = useRef();
	const options = {
		chart: {
			zoomType: 'xy',
			height: '300px',
		},
		plotOptions: {
			column: {
				animation: false,
			},
			line: {
				animation: false,
			},
		},
		exporting: { enabled: false, allowHTML: true },
		credits: { enabled: false },
		title: { text: '' },
		boost: {
			useGPUTranslations: true,
		},
		xAxis: {
			categories: data.map(el => el.dimension),
			crosshair: true,
			lineColor: colors.black,

			title: {
				text: `${breakDownBy}`,
				style: {
					...FONTSTYLE,
					textOverflow: 'ellipsis',
				},
			},
			labels: {
				formatter: function() {
					if (typeof this.value !== 'number') {
						if (this.value === undefined) {
							return '';
						} else {
							if (this.value.length > 0) {
								return `${this.value.substring(0, 4)}...`;
							}
						}
					}
				},
				style: { ...FONTSTYLE },
			},
		},

		legend: {
			enabled: true,
		},
		yAxis: [
			{
				gridLineWidth: 0,
				lineColor: colors.black,
				lineWidth: 1,
				title: {
					text: 'Days',
					style: {
						...FONTSTYLE,
						textOverflow: 'ellipsis',
					},
				},
			},
		],
		tooltip: {
			shared: true,
			useHTML: true,
			backgroundColor: 'rgba(255,255,255, 0.9)',
			borderWidth: 0,
			borderRadius: 2,
			outside: true,
			formatter: function() {
				const { points } = this;
				return renderToString(
					<Tooltip tooltipData={points[0].point.tooltip} />
				);
			},
		},
		series: [
			{
				name: 'Contract Term',
				type: 'line',
				// data:data
				data: data.map(el => ({
					y: el.contractTerm,
					dimension: el.dimension,
					tooltip: generateToolTip({
						'Contract Term': el.contractTerm,
						'Realized Term': el.realizedTerm,
						dimension: el.dimension,
						'Amount Paid': getFormattedSpendWithSymbol(
							el.amtPaid,
							'$',
							true
						).toUpperCase(),
					}),
				})),
			},
			{
				name: 'Realized Term',
				type: 'line',
				// data:[]
				data: data.map(el => ({
					y: el.realizedTerm,
					dimension: el.dimension,
					tooltip: generateToolTip({
						'Contract Term': el.contractTerm,
						'Realized Term': el.realizedTerm,
						dimension: el.dimension,
						'Amount Paid': getFormattedSpendWithSymbol(
							el.amtPaid,
							'$',
							true
						).toUpperCase(),
					}),
				})),
			},
		],
		colors: ['#032E45', '#448EB4'],
		animation: false,
	};

	return (
		<SectionWrapper>
			<Header>
				<Title>Realized Term vs. Contract Term</Title>
			</Header>
			{false ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{data.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<HighchartsReact
							highcharts={Highcharts}
							options={options}
							ref={chartRef}
						/>
					)}
				</>
			)}
		</SectionWrapper>
	);
}

export default LineChart;
